import { tooltipClasses } from '@mui/material';
import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const MuiTooltip: {
    defaultProps?: ComponentsProps['MuiTooltip'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
    variants?: ComponentsVariants['MuiTooltip'];
} = {
    defaultProps: {
        arrow: true,
        placement: 'top',
        disableHoverListener: true,
    },
    styleOverrides: {
        tooltip: (props) => [
            props.theme.typography.body2,
            {
                maxWidth: '300px',
                backgroundColor: props.theme.palette.components.tooltip.bgcolor,
                color: props.theme.palette.components.tooltip.color,
                padding: props.theme.spacing(props.theme.tokens.spacing.xxxs, props.theme.tokens.spacing.xxs),
                borderRadius: props.theme.borderRadius(props.theme.tokens.borderRadius.sm),
                [`& > .${tooltipClasses.arrow}`]: {
                    color: props.theme.palette.components.tooltip.bgcolor,
                },
            },
        ],
    },
};
